<template>
  <div>
    <connection-add-new
      :is-add-new-connection-sidebar-active.sync="isAddNewConnectionSidebarActive"
      @refresh-data="refreshData"
    />
    <b-alert
      show
      variant="info"
    >
      <div class="alert-body">
        <feather-icon
          icon="InfoIcon"
          class="mr-50 mt-25"
        />
        {{ $t('viewSettings.connectionStringsDescription') }}
      </div>
    </b-alert>
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="3"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>{{ $t('Lists.Show') }}</label>
            <v-select
              v-model="perPage"
              :options="perPageOptions"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>{{ $t('Lists.Entries') }}</label>
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('Lists.Search')"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            offset-md="2"
          >
            <b-button
              variant="primary"
              @click="isAddNewConnectionSidebarActive = true"
            >
              <span class="text-nowrap">{{ $t('Lists.Add') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="refConnectionStringsTable"
        :sort-by.sync="sortBy"
        class="position-relative"
        :items="refetchConnectionStrings"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        :empty-text="$t('Lists.NoMatchingRecordsFound') "
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <!-- Edit  -->
            <b-dropdown-item
              :to="{ name: 'settings-dataaccess-connectionstrings-edit', params: { ConnectionId: data.item.cadenaConexionId } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Lists.Edit') }}</span>
            </b-dropdown-item>
            <!-- Delete -->
            <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span
                class="align-middle ml-50"
                @click="showDeleteConfirmation(data.item.cadenaConexionId) "
              >{{ $t('Lists.Delete') }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">{{ $t('Lists.Showing') }} {{ dataMeta.Showing }} {{ $t('Lists.To') }} {{ dataMeta.to }} {{ $t('Lists.Of') }} {{ dataMeta.of }} {{ $t('Lists.Entries') }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalConectionStrings"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BAlert,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
} from 'bootstrap-vue'
import { ref, watch, computed } from '@vue/composition-api'
import vSelect from 'vue-select'
import generalDataService from '@/services/generalData.service'
import i18n from '@/libs/i18n'
import ConnectionAddNew from './ConnectionStringsAddNew.vue'
// import BaseListEdit from '@/views/components/base-list-edit/BaseListEdit.vue'

export default {
  components: {
    BAlert,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    vSelect,
    BDropdown,
    BDropdownItem,
    BPagination,
    // BaseListEdit,

    ConnectionAddNew,
  },
  setup() {
    /* Refs */
    const refConnectionStringsTable = ref(null)
    /* Services */
    const { fetchConnectionStrings } = generalDataService()
    /* Pagination */
    const perPageOptions = [10, 25, 50, 100]
    const perPage = ref(10)
    const currentPage = ref(1)
    /* Params */
    const status = ref('')
    const searchQuery = ref('')
    const isSortDirDesc = ref(false)
    const sortBy = ref('cadenaConexionId')
    /* Data */
    const totalConectionStrings = ref(0)
    const records = ref([])
    const tableColumns = [
      {
        label: i18n.t('DataAccess.ConnectionsStrings.columns.name'),
        key: 'nombre',
      },
      {
        label: i18n.t('DataAccess.ConnectionsStrings.columns.instanceServer'),
        key: 'servidorInstancia',
      },
      {
        label: i18n.t('DataAccess.ConnectionsStrings.columns.nameDatabase'),
        key: 'baseDatosNombre',
      },
      {
        label: i18n.t('DataAccess.ConnectionsStrings.columns.system'),
        key: 'sistema.nombre',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const refetchConnectionStrings = (ctx, callback) => {
      fetchConnectionStrings({
        searchQuery: searchQuery.value,
        limit: perPage.value,
        offSet: currentPage.value === 1 ? 0 : (currentPage.value * perPage.value) - perPage.value,
        sort: `${sortBy.value} ${isSortDirDesc.value ? 'ASC' : 'DESC'}`,
        estado: status.value,
      }, data => {
        records.value = data.cadenasConexion
        totalConectionStrings.value = data.total
        callback(records.value)
      })
    }
    /* UI */

    const isAddNewConnectionSidebarActive = ref(false)
    const dataMeta = computed(() => {
      const localItemsCount = refConnectionStringsTable.value ? refConnectionStringsTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalConectionStrings.value,
      }
    })
    const refreshData = () => {
      refConnectionStringsTable.value.refresh()
    }
    watch([currentPage, perPage, status, searchQuery], () => {
      refreshData()
    })
    const resolveConectionStringsVariant = classification => {
      if (!classification.fechaHoraClasificacion) return 'warning'
      if (classification.fechaHoraClasificacion) return 'success'
      return 'primary'
    }
    const ConectionStringsFilter = [
      i18n.t('DataAccess.ConnectionsStrings.columns.classified'),
      i18n.t('DataAccess.ConnectionsStrings.columns.pending'),
    ]
    return {
      // Ref
      refConnectionStringsTable,
      // Params
      searchQuery,
      sortBy,
      refetchConnectionStrings,
      isSortDirDesc,
      // Data
      tableColumns,
      totalConectionStrings,
      records,
      // UI
      isAddNewConnectionSidebarActive,
      dataMeta,
      ConectionStringsFilter,
      resolveConectionStringsVariant,
      // Pagination
      perPageOptions,
      perPage,
      currentPage,
      status,
      // Event
      refreshData,
    }
  },
  methods: {
    showDeleteConfirmation(CadenaId) {
      let ConnectionId = ref([])
      const { deleteConnectionString } = generalDataService()
      this.$bvModal
        .msgBoxConfirm(i18n.t('DataAccess.ConnectionsStrings.questionDeleteConnectionString'), {
          title: i18n.t('Lists.pleaseConfirm'),
          size: 'sm',
          okVariant: 'primary',
          okTitle: i18n.t('Lists.Yes'),
          cancelTitle: i18n.t('Lists.No'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        }).then(deleteConfirmation => {
          if (deleteConfirmation) {
            ConnectionId = CadenaId
            deleteConnectionString(ConnectionId)
            this.$router.go(0)
          }
        })
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
